module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDBAMAAACYZb3pAAAAElBMVEWlGTGlGTHeuMH09fh7eo4tKkrD6/3SAAAAAXRSTlPUwVjOqwAAADdJREFUeNpjYSAZsAiSroVhVMtw0SI4mmBGtYwmmFEto1pGtQwOLe/pomU0XkYTzGggjyYY4gAAeykGDWlcNi4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/th.png
// module id = 8kYN
// module chunks = 0